import { render, staticRenderFns } from "./GridList.vue?vue&type=template&id=39aefdf1&scoped=true"
import script from "./GridList.vue?vue&type=script&lang=js"
export * from "./GridList.vue?vue&type=script&lang=js"
import style0 from "./GridList.vue?vue&type=style&index=0&id=39aefdf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aefdf1",
  null
  
)

export default component.exports